// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2BKT1","requiredAsterisk":"Info_requiredAsterisk__2tHT0"};